import React, { useEffect } from "react";
import {
  StakingBalanceButton,
  StakingBalanceCard,
  StakingCard,
  StakingCardContainer,
  StakingContainer,
  StakingTopCard,
} from "./Staking.styled";
import { useNavigate } from "react-router-dom";
import { getStakePlans } from "../../feature/stake/StakeActions";
import { useDispatch, useSelector } from "react-redux";

const Staking = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { stakePlans } = useSelector((state) => state.stake);

  useEffect(() => {
    dispatch(getStakePlans({}));
  }, [dispatch]);

  return (
    <StakingContainer>
      <StakingTopCard>
        <StakingBalanceCard>
          <StakingBalanceButton onClick={() => navigate("/stakes")}>
            Stakes
            {/* <h2 style={{ lineHeight: "1px" }}>{"1"}</h2> */}
          </StakingBalanceButton>
          {/* <StakingBalanceButton onClick={() => navigate("/stake-withdraw")}>
            Withdraw
          </StakingBalanceButton> */}
          <StakingBalanceButton onClick={() => navigate("/history")}>
            History
          </StakingBalanceButton>
        </StakingBalanceCard>
      </StakingTopCard>

      <StakingCardContainer>
        {stakePlans.map((data, index, row) => (
          <StakingCard key={index}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div>
                <div style={{ marginBottom: "5px" }}>
                  {data.staking_duration} Days Staking
                </div>
              </div>
              <div>
                <div>Minimum Amount:</div>
                <div style={{ color: "#C597F8", marginBottom: "5px" }}>
                  {data.minimum_amount} TRX
                </div>
              </div>
              <div>
                <div>% of return:</div>
                <div style={{ color: "#C597F8", marginBottom: "5px" }}>
                  {data.percentage}%
                </div>
              </div>
              <div>
                <div>Return on stake:</div>
                <div style={{ color: "#C597F8", marginBottom: "5px" }}>
                  {data.return_on_stake} TRX
                </div>
              </div>
            </div>
            <div style={{ marginBlock: "auto" }}>
              <button
                style={{
                  height: "40px",
                  paddingInline: "40px",
                }}
                onClick={() => {
                  navigate("/stake", { state: { selectedStakePlan: data } });
                }}
              >
                Stake
              </button>
            </div>
          </StakingCard>
        ))}
      </StakingCardContainer>
    </StakingContainer>
  );
};

export default Staking;
